export const GET_LIST_FAVORITE = 'GET_LIST_FAVORITE'
